import moment from "moment";

/**
 * Local timezone
 */
export const formatDateTime = (date: string) =>
  moment(date).format("YYYY-MM-DD HH:mm");
export const formatDate = (date: string) => moment(date).format("YYYY-MM-DD");
export const formatTime = (date: string) => moment(date).format("HH:mm");
export const formatTimeFromTime = (date: string) =>
  moment(date, "HH:mm").format("HH:mm");

export const getDuration = (start: string, end: string) => {
  const duration = moment.duration(moment(start).diff(moment(end)));

  return Math.abs(duration.asHours());
};

export const isSameDay = (firstDate: string, secondDate: string) => {
  return moment(firstDate).isSame(moment(secondDate), "day");
};

/**
 * UTC timezone
 */
export const formatUTCDateTime = (date: string) =>
  moment.utc(date).format("YYYY-MM-DD HH:mm");
export const formatUTCDate = (date: string) =>
  moment.utc(date).format("YYYY-MM-DD");
export const formatUTCTime = (date: string) => moment.utc(date).format("HH:mm");

export const isTodayUTC = (startDate: Date | null, endDate: Date | null) =>
  moment.utc(startDate).isSame(moment.utc(), "day") &&
  moment.utc(endDate).isSame(moment.utc().add("1", "day"), "day");

export const isTomorrowUTC = (startDate: Date | null, endDate: Date | null) =>
  moment.utc(startDate).isSame(moment.utc().add("1", "day"), "day") &&
  moment.utc(endDate).isSame(moment.utc().add("2", "day"), "day");

/**
 * Other
 */

export const extractDaysFromNote = (note?: string) => {
  let days = "";

  if (note) {
    const match = note.match(/([\d.]+) *days/);

    if (match && match[0]) {
      days = ` (+${match[0]})`;
    }
  }

  return days;
};
